<div class="td-wb-learn-lesson-info">
  <div class="td-wb-learn-lesson-info__time">
    @if (lesson()?.createdDate) {
      <div class="td-wb-learn-lesson-info__tags">
        <td-wb-icon class="td-wb-learn-lesson-info__icon"
                    iconId="calendar-alt--small" />
        <span translate="tdWb.learn.lessonInfo.POSTED"></span>
        <span class="td-wb-learn-lesson-info__lesson-date"
              [translate]="lesson().createdDate | tdWbDate"></span>
      </div>
    }
    @if (lesson()?.duration) {
      <div class="td-wb-learn-lesson-info__tags">
        <td-wb-icon class="td-wb-learn-lesson-info__icon"
                    iconId="clock--small" />
        <span class="td-wb-vh">, </span>
        <span [innerText]="lesson().duration | tdWbDuration: { useWords: true, truncateTo: 'seconds' }"></span>
      </div>
    }
  </div>
  @if (showFilters()) {
    <div class="td-wb-learn-lesson-info__filter">
      <div class="td-wb-learn-lesson-info__icon-tags">
        <td-wb-icon class="td-wb-learn-lesson-info__icon"
                    iconId="tag--small" />
      </div>
      <div class="td-wb-learn-lesson-info__tags"
           role="list"
           [attr.aria-label]="'tdWb.learn.lessonInfo.TAGS' | tdWbTranslate">
        @for (filter of lesson().filters; track filter; let isLast = $last) {
          <span role="listitem">{{ filter }}{{ isLast ? '' : ', ' }}</span>
        }
      </div>
    </div>
  }
</div>
